<template>
  <b-card no-body>
    <b-card-header class="border-0">
      <b-row >
        <b-col cols="6">
          <h3 class="mb-0">Groups</h3>
        </b-col>
        <b-col cols="6" class="text-right">
          <!-- <el-tooltip content="Add a new Group" placement="top"> -->
            <base-button type="primary" icon size="sm" @click="addGroup()">
              <!-- <span class="btn-inner--icon"><i class="fas fa-edit"></i></span> -->
              <span class="btn-inner--text">Add</span>
            </base-button>

          <!-- </el-tooltip> -->
        </b-col>
      </b-row>
    </b-card-header>
    <b-col cols="12" class="d-flex justify-content-center justify-content-sm-between">
      <el-select
        class="select-primary pagination-select p-2"
        v-model="pagination.perPage"
        placeholder="Per page"
      >
        <el-option
          class="select-primary"
          v-for="item in pagination.perPageOptions"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>

      <div class="filler"></div>
      <div class="p-2 same-width">
        <base-input v-model="searchText"
                    prepend-icon="fas fa-search"
                    placeholder="Search...">
        </base-input>
      </div>
      <el-select class="select-primary pagination-select p-2 same-width" v-model="selects.simple" filterable placeholder="Select Column">
        <!-- <el-option Selected disabled value="x">-- Please Select Column --</el-option> -->
        <el-option v-for="option in selectOptions" :key="option.key" :label="option.value" v-bind:value="option.key">
        </el-option>
      </el-select>

      <div class="p-2">
        <base-button icon type="primary" size="sm" @click.prevent="searchGroupList()">Search</base-button>
      </div>
    </b-col>
    <el-table class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="queriedData"
              @sort-change="sortChange"
              @selection-change="selectionChange"
              row-key="group_id">
      <el-table-column label="id"
                       min-width="100px"
                       prop="group_id"
                       sortable>
        <template v-slot="{row}">
          <b>{{row.group_id}}</b>
        </template>
      </el-table-column>

      <el-table-column label="Name"
                       prop="group_name"
                       min-width="150px"
                       sortable>
        <template v-slot="{row}">
          <b>{{row.group_name}}</b>
        </template>
      </el-table-column>

      <el-table-column label="Subsidiary"
                       min-width="150px"
                       prop="sub_name"
                       sortable>
        <template v-slot="{row}">
          <b>{{row.sub.sub_name}}</b>
        </template>
      </el-table-column>

      <el-table-column label="Created By"
                       min-width="150px"
                       prop="created_by"
                       sortable>
        <template v-slot="{row}">
          <b>{{row.created_by.name}}</b>
        </template>
      </el-table-column>

      <el-table-column min-width="300px" align="center">
        <div slot-scope="{row}" class="table-actions">
          <!-- <el-tooltip content="Edit" placement="top">
            <a href="#!" @click.prevent="onEdit(row)" class="table-action" data-toggle="tooltip" data-original-title="Group Edit">
              <i class="fas fa-edit"></i>
            </a>
          </el-tooltip>
          <el-tooltip content="Settings" placement="top">
            <a href="#!" @click.prevent="onSetting(row)" class="table-action" data-toggle="tooltip" data-original-title="Group Setting">
              <i class="fas fa-cog"></i>
            </a>
          </el-tooltip>
          <el-tooltip content="Members" placement="top">
            <a href="#!" @click.prevent="onMember(row)" class="table-action" data-toggle="tooltip" data-original-title="Group Members">
              <i class="fas fa-users"></i>
            </a>
          </el-tooltip>
          <el-tooltip content="Docs" placement="top">
            <a href="#!" @click.prevent="onDoc(row)" class="table-action" data-toggle="tooltip" data-original-title="Group Docs">
              <i class="fas fa-file"></i>
            </a>
          </el-tooltip>
          <el-tooltip content="Delete" placement="top">
            <a href="#!" @click.prevent="onDelete(row)" class="table-action table-action-delete" data-toggle="tooltip"
               data-original-title="Delete product">
              <i class="fas fa-trash"></i>
            </a>
          </el-tooltip> -->
          <base-button type="primary" icon size="sm" @click.prevent="onEdit(row)">
            <span class="btn-inner--text">Edit</span>
            </base-button>
          <base-button type="primary" icon size="sm" @click.prevent="onSetting(row)">
            <span class="btn-inner--text">Settings</span>
          </base-button>
          <base-button type="primary" icon size="sm" @click.prevent="onMember(row)">
            <span class="btn-inner--text">Members</span>
          </base-button>
          <base-button type="primary" icon size="sm" @click.prevent="onDoc(row)">
            <span class="btn-inner--text">Docs</span>
          </base-button>
          <base-button type="primary" icon size="sm" @click.prevent="onDelete(row)">
            <span class="btn-inner--text">Delete</span>
          </base-button>
        </div>
      </el-table-column>
    </el-table>
    <div
      slot="footer"
      class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
    >
      <div class="">
        <p class="card-category">
          Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

          <span v-if="selectedRows.length">
            &nbsp; &nbsp; {{selectedRows.length}} rows selected
          </span>
        </p>

      </div>
      <base-pagination
        class="pagination-no-border"
        :current="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
        @change="paginationChanged($event)"
      >
      </base-pagination>
    </div>

  </b-card>

</template>
<script>
  import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip, Select, Option } from 'element-ui'
  import axios from 'axios'
  import {apiDomain, getHeader} from '@/assets/js/config.js'
  import ErrorFunctionMixin from '@/assets/js/errorFunctionMix.js'
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';
  import { BasePagination } from '@/components';
  import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
  import debounce from 'lodash.debounce';

  export default {
    name: 'groups-table',
    mixins: [ErrorFunctionMixin,clientPaginationMixin],
    components: {
      BasePagination,
      [Select.name]: Select,
      [Option.name]: Option,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
    },
    data() {
      return {
        propsToSearch:['group_name'],
        tableData: [],
        currentPage: 1,
        mode: 'listing',
        selectedRows: [],
        searchText: null,
        debouncedHandler:null,
        TableColumn:[{
          type: 'selection'
        }],
        selects: {
          simple: 'all',
        },
        selectOptions: [
          {
            key:'all',
            value:'All'
          },
          {
            key :'group_name',
            value: 'Name'
          },
          {
            key :'sub_name',
            value: 'Subsidiary'
          },
          {
            key :'created_by',
            value: 'Created By'
          }
        ],
      };
    },
    mounted(){
      this.groupList()
    },
    methods: {
      paginationChanged(page) {
        this.pagination.currentPage = page
      },
      selectionChange(selectedRows) {
      this.selectedRows = selectedRows
      },
      addGroup(){
        this.$router.push({path: '/group/addGroups' })
      },
      onEdit(row) {
        this.$router.push({path: '/group/editGroups/' + row.group_id })
      },
      onSetting(row) {
        this.$router.push({path: '/group/settingGroup/' + row.group_id })
      },
      onMember(row) {
        this.$router.push({path: '/group/memberGroup/' + row.group_id })
      },
      onDoc(row) {
        this.$router.push({path: '/group/docGroup/' + row.group_id })
      },
      onDelete(row) {
        swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          // showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          // denyButtonText: `Don't save`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            axios.delete(apiDomain + 'groups/group/' + row.group_id,{ headers: getHeader() })
            .then ( response => {
              if (response.status === 200)
              {
                this.$notify({
                  message:
                    '<b>Group : ' + row.group_name + '</b> - Successfully Deleted.',
                  timeout: 10000,
                  icon: 'ni ni-bell-55',
                  type: 'default',
                });
                this.groupList()
              }
            })
            .catch ( error => {
                console.log(error.response.status)
                this.errorFunction(error, "Delete App Type")
                
            });
          } 
        })
      },
      groupList(){
        axios.get(apiDomain + 'groups/group', { headers: getHeader() })
        .then(response => {
          this.tableData = response.data.data
        })
        .catch ( error => {
            console.log(error.response.status)
            this.errorFunction(error, "Delete App Type")
            
        });
        const str = JSON.stringify(this.tableData, null, 2);
        console.log(str);
      },
      searchGroupList()
      {
        if(this.selects.simple == "all"){
          this.$notify({
            message:
              '<b>Group : </b> - Search Successful.',
            timeout: 10000,
            icon: 'ni ni-bell-55',
            type: 'default',
          });
          return this.groupList()
        }
        const postData = {
          search_by  : this.selects.simple,
          search_value : this.searchText,
        }

        axios.post(apiDomain + 'groups/data_search.group', postData  ,{ headers: getHeader() })
        .then ( response => {
          if(response.data.data.length === 0){
            return this.$notify({
              message:
                '<b>Group : </b> - No Results.',
              timeout: 10000,
              icon: 'ni ni-bell-55',
              type: 'default',
            });
          }
          if (response.status === 200)
          {
            this.tableData = response.data.data
            console.log(this.tableData)
            this.searchText = null
            this.$notify({
              message:
                '<b>Group : </b> - Search Successful.',
              timeout: 10000,
              icon: 'ni ni-bell-55',
              type: 'default',
            });

          }
        })
        .catch ( error => {
            console.log(error.response.status)
            this.errorFunction(error, "Group Listing")
        });
      }

    }
  }
</script>
<style scoped>
.filler{flex-grow:1; text-align:center}
@media only screen and (max-width: 600px) {
  .same-width {
    width: 100%;
  }
}
</style>